import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { closeOverlay } from 'app/shared/modules/overlay/actions';

import { TokenWarning } from './TokenWarning';

const IntlTokenWarning = injectIntl(TokenWarning);

export const ConnectedTokenWarning = connect(
  null,
  { closeOverlay },
)(IntlTokenWarning);
